import { Box, Paper, Typography } from "@mui/material";
import React from "react";
import styles from "../../styles/components/manager-submitted-videotabpanel.module.scss";
import { Link } from "react-router-dom";
import MgTabpendingreviewIcon from "../../ui/Icons/MgTabpendingreviewIcon";
import MgTabinquiryIcon from "../../ui/Icons/MgTabinquiryIcon";
import MgTabduplicationIcon from "../../ui/Icons/MgTabduplicationIcon";
import { useLocation } from "react-router-dom";
import { usePost } from "../../hooks/api/useFetch";
import { parseCookies } from "nookies";

export default function ManagerSubmittedVideoTabPanel() {
  const { pathname } = useLocation();

  const cookies = parseCookies();
  const userData = JSON.parse(cookies?.userdetails || "{}");

  const {
    data: managerSubmissionsData,
    isLoading: managerSubmissionsIsLoading,
    isSuccess: managerSubmissionsIsSuccess,
  } = usePost(["manager-submissions", userData?.id], "manager/submissions", {
    user_id: userData.id,
  });
  return (
    <>
      <Paper elevation={0} className={styles.tabPnelPaper}>
        <Link
          to={"/manager-dashboard/submitted-videos/pending"}
          className={
            pathname == "/manager-dashboard/submitted-videos/pending"
              ? `${styles.linkActive} ${styles.forPendingTab}`
              : `${styles.forPendingTab}`
          }
        >
          <figure>
            <MgTabpendingreviewIcon />
          </figure>
          <Box className={styles.tabType}>
            <Typography variant="body2">Pending Videos</Typography>
            <Typography variant="caption">
              {managerSubmissionsData?.data?.data?.submissions?.pending
                ? managerSubmissionsData?.data?.data?.submissions?.pending
                : "-"}
            </Typography>
          </Box>
        </Link>
        <Link
          to={"/manager-dashboard/submitted-videos/inquiring"}
          className={
            pathname == "/manager-dashboard/submitted-videos/inquiring"
              ? `${styles.linkActive} ${styles.forPendingTab}`
              : `${styles.forPendingTab}`
          }
        >
          <figure>
            <MgTabinquiryIcon />
          </figure>
          <Box className={styles.tabType}>
            <Typography variant="body2">Inquiring Videos</Typography>
            <Typography variant="caption">
              {managerSubmissionsData?.data?.data?.submissions?.inquiry
                ? managerSubmissionsData?.data?.data?.submissions?.inquiry
                : "-"}
            </Typography>
          </Box>
        </Link>
        <Link
          to={"/manager-dashboard/submitted-videos/duplications"}
          className={
            pathname == "/manager-dashboard/submitted-videos/duplications"
              ? `${styles.linkActive} ${styles.forPendingTab}`
              : `${styles.forPendingTab}`
          }
        >
          <figure>
            <MgTabduplicationIcon />
          </figure>
          <Box className={styles.tabType}>
            <Typography variant="body2">Duplicated Videos</Typography>
            <Typography variant="caption">
              {managerSubmissionsData?.data?.data?.submissions?.duplicate
                ? managerSubmissionsData?.data?.data?.submissions?.duplicate
                : "-"}
            </Typography>
          </Box>
        </Link>
      </Paper>
    </>
  );
}
